import * as React from "react";
import { Redirect } from "react-router-dom";
import SortableTbl from "react-sort-search-table";
import Loader from "react-loader";
import { toast, ToastContainer } from "react-toastify";
import { Button, Col, Input, Row } from "reactstrap";
import Modal from "react-awesome-modal";

import FormModal from "../../../../components/Admin/FormModal/FormModal";
import FormFieldClass from "../../../../components/Admin/FormModal/FormFieldClass";
import Navbar from "../../../../components/CustomNav/CustomNav.Component";
import SimpleLoader from "../../../../components/SimpleLoader/SimpleLoader.Component";

import withServices from "../../../../HOCs/withServices";
import { SOCKET as socket } from "../../../../common/constants";

import { Wrapper, Content, ContentRow } from "./ListLessons.styles";

interface IProps {
  services?: any;
  location?: any;
  match?: any;
  history?: any;
}

interface IState {
  toLogin: boolean;
  loaded: boolean;
  data: any;
  selectedLesson: string;
  isNavigate: boolean;
  destination: string;
  socketLoading: boolean;
  sid: string;
  lessonId: any;
  duplicateModal: boolean;
  lessonName: string;
}

class ListLessons extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      destination: "",
      toLogin: false,
      loaded: true,
      isNavigate: false,
      data: {},
      selectedLesson: "",
      socketLoading: false,
      sid: "",
      lessonId: null,
      duplicateModal: false,
      lessonName: "",
    };

    this.lessonSubmit = this.lessonSubmit.bind(this);
    this.fetchLessonDetails = this.fetchLessonDetails.bind(this);
  }

  public async componentDidMount() {
    const {
      match,
      history,
      location,
      services: { isUserLoggedIn, adminAPI, currentUserID },
    } = this.props;

    if (!isUserLoggedIn) {
      this.setState({ toLogin: true });
    }

    const {
      params: { id: InteractionID },
    } = match;

    const assetCollectionsDataKey = [
      "id",
      "Title",
      "Assessment",
      "Created",
      "delete",
    ];

    const assetCollectionsThead = [
      "ID",
      "Name",
      "Assessment",
      "Date",
      "Action",
    ];

    const lessonFormValues = {
      Assessment: "",
      User: currentUserID,
      Name: "",
      Description: "",
      Duration: "",
    };

    const [lessonsRes, assessmentsRes] = await Promise.all([
      adminAPI.getLessons(),
      adminAPI.getAssessments(),
    ]);

    if (lessonsRes.ok) {
      const lessonFormFields = [
        {
          id: "Assessment",
          name: "Assessment",
          type: "option",
          placeholder: "Enter Assessment",
          options: {
            items: assessmentsRes.data.assessments,
            idkey: "id",
            labelkey: "Title",
            valuekey: "id",
          },
          required: false,
        },
        {
          id: "Name",
          name: "Name",
          type: "text",
          placeholder: "Enter Name",
          required: true,
        },
        {
          id: "Description",
          name: "Description",
          type: "text",
          placeholder: "Enter Description",
          required: true,
        },
        {
          id: "Duration",
          name: "Duration",
          type: "number",
          dim: {
            min: 1,
            max: 1000,
          },
          placeholder: "Enter Duration in minutes",
          required: true,
        },
      ] as FormFieldClass[];

      const collections = lessonsRes.data.lessons;

      this.setState({
        data: {
          collections,
          loaded: true,
          lessonFormFields,
          lessonModal: false,
          lessonFormValues,
          collectionsdatakey: assetCollectionsDataKey,
          collectionsthead: assetCollectionsThead,
        },
      });
    } else {
      toast.error("Error fetching interaction details!");
    }
  }

  public async fetchLessonDetails() {
    const assetCollectionsRes = await this.props.services.adminAPI.getLessons();

    if (assetCollectionsRes.ok) {
      const collections = assetCollectionsRes.data.lessons;

      const data = this.state.data;

      data.collections = collections;

      this.setState({ data });
    }
  }

  public onGoBack = () => {
    const dest = this.props.services.currentBaseUrl + "home/";

    this.setState({
      isNavigate: true,
      destination: dest,
    });
  };

  public onGoToCreate = () => {
    const dest = this.props.services.currentBaseUrl + "interactions_creator";

    this.setState({
      isNavigate: true,
      destination: dest,
    });
  };

  public onLogout = () => {
    this.setState({ toLogin: true });
  };

  public toggleDuplicateModal = () => {
    const { duplicateModal } = this.state;
    this.setState({ duplicateModal: !duplicateModal });
  };

  public goToEdit = (row) => {
    this.props.history.push(
      `${this.props.services.currentBaseUrl}lessonbuilder/${row.rowData.id}`
    );
  };

  public onSocketConnect = () => {
    console.log("connected");
  };

  public onMessage = (socketMessage) => {
    this.setState({ socketLoading: false, duplicateModal: true });
    console.log("message received");

    // kill socket when done
    socket.off("customNotif");

    // refresh lesson list
    this.fetchLessonDetails();
  };

  public onSetup = (message, id) => {
    this.setState({ sid: message.id });
    this.duplicateLesson(id, message.id);
  };

  public async delete(row) {
    const retVal = confirm("Do you want to continue ?");

    if (retVal === true) {
      const res = await this.props.services.adminAPI.deleteItemGeneral(
        "lessons",
        row.rowData.id
      );
      if (res.ok) {
        this.fetchLessonDetails();
      }
      return true;
    } else {
      return false;
    }
  }

  public duplicate = (row) => {
    const val = confirm("Are you sure you want to duplicate this lesson?");
    if (!val) {
      return;
    }

    this.setState({
      socketLoading: true,
      lessonId: row.rowData.id,
      lessonName: row.rowData.Title,
    });

    socket.on("connect", this.onSocketConnect);

    socket.on("customEmit", (data) => this.onSetup(data, row.rowData.id));

    socket.on("customNotif", (data) => this.onMessage(data));

    socket.emit("customMsg", { evt: "init" });
  };

  public async duplicateLesson(lessonId, sid) {
    //   const { sid, lessonId} = this.state;
    const {
      services: { adminAPI },
    } = this.props;

    const res = await adminAPI.duplicateLesson(lessonId, sid);
    if (res.ok) {
      toast.info("Duplication started...");
    } else {
      toast.error("Lesson duplication failed, try again");
    }
  }

  public customTD = (props) => {
    return (
      <td>
        <button
          style={{ margin: "3px" }}
          className="blue-button view-more-data table-action"
          onClick={this.goToEdit.bind(this, props)}
        >
          Edit
        </button>

        <button
          style={{ margin: "3px" }}
          className="blue-button view-more-data table-action"
          onClick={this.delete.bind(this, props)}
        >
          Delete
        </button>

        <button
          style={{ margin: "3px" }}
          className="blue-button view-more-data table-action"
          onClick={this.duplicate.bind(this, props)}
        >
          Duplicate
        </button>
      </td>
    );
  };

  public lessonToggle = () => {
    const data = this.state.data;
    data.lessonModal = !data.lessonModal;
    this.setState({
      data,
    });
  };

  public async lessonSubmit(e) {
    e.preventDefault();

    this.setState({
      loaded: false,
    });

    const item = this.state.data.lessonFormValues;

    const res = await this.props.services.adminAPI.createItemGeneral(
      "lessons",
      item
    );

    if (res.ok) {
      this.lessonToggle();

      const lessonsRes = await this.props.services.adminAPI.getLessons();

      if (lessonsRes.ok) {
        const data = this.state.data;

        data.collections = lessonsRes.data.lessons;

        this.setState({
          data,
        });
      }
    } else {
      toast.error("Error creating item!");
    }

    this.setState({
      loaded: true,
    });
  }

  public renderDuplicateModal = () => {
    const { duplicateModal, lessonName } = this.state;

    return (
      <Modal
        visible={duplicateModal}
        effect="fadeInDown"
        height="300"
        width="400"
        onClickAway={this.toggleDuplicateModal}
      >
        <div
          style={{ height: "300px", padding: "20px" }}
          className="exit-modal-container"
        >
          <p
            style={{
              color: "#fff",
              fontSize: "18px",
              fontWeight: "bold",
              fontStyle: "italic",
              textAlign: "center",
            }}
          >
            New Lesson:{" "}
            <span style={{ color: "#acff24" }}>copy of {lessonName}</span>
          </p>
          <i
            style={{ fontSize: "48px", marginBottom: "20px" }}
            className="fa fa-check"
          />
          <div className="exit-warning-buttons">
            <button className="blue-button" onClick={this.toggleDuplicateModal}>
              Done
            </button>
          </div>
        </div>
      </Modal>
    );
  };

  public render() {
    const { data } = this.state;

    if (this.state.toLogin) {
      return <Redirect to="/login" />;
    }

    if (this.state.isNavigate) {
      return <Redirect to={this.state.destination} />;
    }

    if (Object.keys(data).length === 0) {
      return <Loader color="#acff24" />;
    }

    return (
      <Wrapper>
        <ToastContainer />
        <Navbar logoutParent={this.onLogout} />
        {this.renderDuplicateModal()}
        <Content>
          <ContentRow className="single-col">
            <p className="go-back" onClick={this.onGoBack}>
              &lt; Back
            </p>
          </ContentRow>
        </Content>

        <Content>
          <Button onClick={this.lessonToggle}>Add New</Button>
          <SortableTbl
            tblData={data.collections}
            tHead={data.collectionsthead}
            dKey={data.collectionsdatakey}
            customTd={[
              { custd: this.customTD, keyItem: "edit", sortable: false },
              { custd: this.customTD, keyItem: "delete", sortable: false },
              { custd: this.customTD, keyItem: "duplicate", sortable: false },
            ]}
            defaultCSS={false}
          />
        </Content>

        <ContentRow>
          <FormModal
            visible={data.lessonModal}
            toggle={this.lessonToggle}
            formsubmit={this.lessonSubmit}
            formfields={data.lessonFormFields}
            values={data.lessonFormValues}
            isbusy={!this.state.loaded}
          />
        </ContentRow>
        {this.state.socketLoading ? (
          <SimpleLoader text="Duplication Ongoing..." />
        ) : (
          ""
        )}
      </Wrapper>
    );
  }
}

export default withServices(ListLessons);



// WEBPACK FOOTER //
// ./src/pages/Admin/Lessons/ListLessons/ListLessons.tsx